
<b-row>
  <JsonField
    v-model="data"
    name="data"
    class="col-12"
    @error="setHasError(true)"
    @input="setHasError(false)"
  />
  <FormActions :on-submit="save" :on-cancel="cancel" />
</b-row>
